module.exports = __webpack_public_path__ + "images/emoji/punch.3ca75e1d84eaeea88a82.png";